import { toast } from '@/components/bs-ui/toast/use-toast'
import axios from 'axios'

/* 下载word参数 */
export type saveToWordParamsType = {
  name: string
  content: string
}

/* 下载word */
export const downloadWord = async (saveToWordParams: saveToWordParamsType) => {
  try {
    const response = await axios.post('/api/v1/assistant/save_to_word', saveToWordParams, {
      responseType: 'blob' // 关键：设置响应类型为 blob
    })

    // 提取文件名
    const disposition = response.headers['content-disposition']
    let filename = 'download.docx'

    if (disposition) {
      const fileNameMatch = disposition.match(/filename\*?=([^;]+)/i)
      if (fileNameMatch) {
        const rawFileName = decodeURIComponent(fileNameMatch[1].replace(/UTF-8''/, '').replace(/"/g, ''))
        filename = rawFileName
      }
    }

    // 创建 blob 和链接
    const blob = new Blob([response.data], {
      type:
        response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    })

    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(url) // 清理 URL
  } catch (error) {
    console.error('下载失败:', error)
    // app 弹窗
    toast({
      title: `提示`,
      variant: 'error',
      description: '导出word失败'
    })
  }
}
